<template>
  <v-dialog
    v-model="localValue"
    content-class="dialog-time-difference"
    max-width="500"
    lazy
    persistent
  >
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>
          {{ $t('titles.global.confirmation') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <span class="subheading" v-html="text" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="cancel" />

        <v-btn small color="primary" @click="submit">
          {{ $t('action.buttons.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
export default {
  name: 'DialogTimeDifference',
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    time: {
      type: String,
      required: false,
      default: '',
    },
    timeAutoStreaming: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String,
      required: false,
      default: 'match',
    },
  },
  data() {
    return {
      text: '',
      localDialog: false,
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value || this.localDialog
      },
      set(value) {
        this.$emit('input', value)
        this.localDialog = value
      },
    },
  },
  methods: {
    submit() {
      this.$emit('submit')
      this.close()
    },
    show() {
      this.localValue = true
    },
    close() {
      this.localValue = false
    },
    cancel() {
      this.$emit('cancel')

      this.localValue = false
    },
    checkTimeDifference(
      timeValue = this.time,
      timeAutoStreamingValue = this.timeAutoStreaming
    ) {
      if (!timeValue || !timeAutoStreamingValue) return

      let time = moment(timeValue, 'HH:mm')
      let timeAutoStreaming = moment(timeAutoStreamingValue, 'HH:mm')

      if (time.isValid() && timeAutoStreaming.isValid()) {
        if (time.isBefore(timeAutoStreaming)) {
          this.text = this.$t('titles.matches.timeLower', {
            type: this.$tc(`models.${this.type}`),
            time: timeValue,
            timeAutoStreaming: timeAutoStreamingValue,
          })
        } else if (Math.abs(time.diff(timeAutoStreaming)) > 15 * 60 * 1000) {
          this.text = this.$t('titles.matches.timeDifference', {
            type: this.$tc(`models.${this.type}`),
            time: timeValue,
            timeAutoStreaming: timeAutoStreamingValue,
          })
        } else {
          this.text = ''
          this.close()
        }
        if (this.text) this.show()
      }
    },
  },
}
</script>

<style scoped>
.dialog-time-difference {
  z-index: 2400 !important;
}
</style>
